import React, { ReactElement, useEffect, useMemo } from 'react';
import { Form } from 'formik';
import { useDataCollection } from '../../../../../hooks';
import { InjectedWizardStepProps } from '../../../../components/Steps/WizardStep';
import { DataCollectionValues } from '../../../../../types';
import FormControl from '../../../../components/Form/FormControl';
import StepHeader from '../../../../components/Layout/StepHeader';
import InfoCard from '../../../../components/Layout/InfoCard';
import { TextsStepBuildingVolumeVPENB } from '../../../../../data/dictionary';

interface FormError {
    buildingVolumeV?: string;
}

const stepValidation = (values: DataCollectionValues) => {
    const errors: FormError = {};

    if (!values.buildingVolumeV || Number(values.buildingVolumeV) < 0) {
        errors.buildingVolumeV = 'Povinné pole';
    }

    return errors;
};

const StepBuildingVolumeVPENB = ({ completeStep }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, handleBlur, values } = useDataCollection();

    const errors = useMemo(() => stepValidation(values), [values]);
    useEffect(() => {
        completeStep && completeStep(!Object.keys(errors).length);
    }, [errors]);

    return (
        <Form>
            <StepHeader title="Objem budovy V" subtitle="Vyplňte prosím hodnotu z průkazu Vaší budovy" />
            <InfoCard img="objem-budovy-V.jpg" texts={TextsStepBuildingVolumeVPENB} />
            <div className="otz-house-info otz-house-info-small">
                <div className="otz-house-info__item">
                    <div className="otz-house-info__inner">
                        <div className="otz-house-info__title-small">Objem budovy V</div>
                        <div className="otz-house-info__select">
                            <div className="form-container form-container--text">
                                <FormControl
                                    name="buildingVolumeV"
                                    id="buildingVolumeV"
                                    type="number"
                                    tag="input"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.buildingVolumeV}
                                    error={errors.buildingVolumeV}
                                />
                                <div className="wiz-form-text">
                                    m<sup>3</sup>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default StepBuildingVolumeVPENB;
